"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GazetteerBase = void 0;
var olProj = require("ol/proj");
var Style_1 = require("ol/style/Style");
var Text_1 = require("ol/style/Text");
var Fill_1 = require("ol/style/Fill");
var Vector_1 = require("ol/layer/Vector");
var Vector_2 = require("ol/source/Vector");
var ol_1 = require("ol");
var Point_1 = require("ol/geom/Point");
var olSphere = require("ol/sphere");
var GazetteerBase = /** @class */ (function () {
    function GazetteerBase(_map, _textPack, _apikey, _elementId, _btnCssClass, _iconCssClass, _clearerCssClass) {
        if (_apikey === void 0) { _apikey = ""; }
        if (_elementId === void 0) { _elementId = "gazetteer"; }
        if (_btnCssClass === void 0) { _btnCssClass = "btn btn-primary"; }
        if (_iconCssClass === void 0) { _iconCssClass = "fa fa-search"; }
        if (_clearerCssClass === void 0) { _clearerCssClass = "fa fa-times"; }
        var _this = this;
        this._map = _map;
        this._textPack = _textPack;
        this._apikey = _apikey;
        this._elementId = _elementId;
        this._btnCssClass = _btnCssClass;
        this._iconCssClass = _iconCssClass;
        this._clearerCssClass = _clearerCssClass;
        this._initialised = false;
        this.initBase = function () {
            if (!_this._initialised) {
                //strip-loader should take this out for production
                console.log("Initialising geonames");
                _this._displayProjection = _this._map.olMap.getView().getProjection();
                _this._element = $("#".concat(_this._elementId));
                _this.initHtml();
                //get an handle on all the html elements
                _this._resultsSelect = $("#gazetteerSelect");
                _this._input = $("#gazetteerInput");
                _this._noResults = $("#noResults");
                _this._loadingIndicator = $("#gazLoading");
                _this.initPointLayer();
                _this.addHandlers();
                _this._initialised = true;
            }
        };
        this.initPointLayer = function () {
            _this._pointLayer = new Vector_1.default({
                source: new Vector_2.default()
            });
            _this.locationPinStyle = new Style_1.default({
                text: new Text_1.default({
                    text: '\uf3c5',
                    font: 'normal 52px "Font Awesome 6 Pro"',
                    textBaseline: 'bottom',
                    fill: new Fill_1.default({
                        color: '#ff0000'
                    })
                })
            });
            _this._map.olMap.addLayer(_this._pointLayer);
        };
        this.initHtml = function () {
            var gazetterHtml = "\n                <div class=\"mb-3 has-feedback\">\n                    <div class=\"input-group\">\n                        <label class=\"visually-hidden\" for=\"gazetteerInput\">".concat(_this._textPack.locationPostcode, "</label>\n                        <input id=\"gazetteerInput\" type=\"text\" spellcheck=\"false\" class=\"form-control hasclear\"  autocomplete=\"off\" placeholder=\"").concat(_this._textPack.locationPostcode, "\" />\n                        <span class=\"clearer form-control-feedback\"><i class=\"").concat(_this._clearerCssClass, "\" aria-hidden=\"true\"></i></span>                       \n                        <button id=\"btnSearch\" class=\"").concat(_this._btnCssClass, "\" aria-label=\"Search ").concat(_this._textPack.locationPostcode, "\"><i class=\"").concat(_this._iconCssClass, "\" aria-hidden=\"true\"></i></button>                                               \n                    </div>\n                </div>\n\n                <div class=\"mb-3\">\n                    <label class=\"visually-hidden\" for=\"gazetteerSelect\">Select ").concat(_this._textPack.locationPostcode, "</label>\n                    <select id=\"gazetteerSelect\"\n                            style=\"display: none;overflow-x:auto;\"\n                            class=\"form-select\"\n                            size=\"1\"></select>\n                </div>\n\n                <div class=\"mb-3\">                   \n                    <div id=\"gazLoading\" class=\"gazLoading\" style=\"display:none\">\n                        <div class=\"line-scale\"><div></div><div></div><div></div><div></div><div></div></div>\n                    </div>\n                    <span id=\"noResults\" style=\"display:none\">").concat(_this._textPack.noResultsFound, "</span>\n                </div>\n         ");
            _this._element.append(gazetterHtml);
        };
        this.addHandlers = function () {
            var self = _this;
            //setup the clearer on the input textbox
            $(".hasclear").on("keyup", function () {
                var t = $(this);
                t.next('span').toggle(Boolean(t.val()));
            });
            $(".clearer").hide(function () {
                $(this).prev('input').val();
            });
            $(".clearer").on("click", function () {
                $(this).prev('input').val('').trigger("focus");
                $(this).hide();
                self._resultsSelect.empty();
                self._resultsSelect.hide();
                self._noResults.hide();
                self._pointLayer.getSource().clear();
            });
            //set the input click and enter key press handlers
            self._input.on("keypress", function (e) {
                if (e.key === "Enter") {
                    self.find(self._input.val());
                }
            });
            self._input.nextAll("#btnSearch").on("click", function () {
                self.find(self._input.val());
            });
            self._resultsSelect.on("change", function (event) {
                self.showOnMap();
            });
        };
        this.showOnMap = function () {
            var i = parseInt(_this._resultsSelect[0][_this._resultsSelect.prop("selectedIndex")].dataset.resultIndex);
            if (_this._searchResults.length > 0 && _this._searchResults.length >= i) {
                var coord = [_this._searchResults[i].Easting, _this._searchResults[i].Northing];
                _this.addLocationPin(coord);
                _this.addPinAndCenterMap(coord, _this._searchResults[i].ZoomLevel);
            }
        };
        this.addPinAndCenterMap = function (coord, zoomToLevel) {
            _this.addLocationPin(coord);
            _this._map.olMap.getView().setCenter(coord);
            _this._map.olMap.getView().setZoom(zoomToLevel);
        };
        this.addLocationPin = function (displayCoordinates) {
            var locationFeature = new ol_1.Feature({
                geometry: new Point_1.default(displayCoordinates),
            });
            locationFeature.setStyle(_this.locationPinStyle);
            _this._pointLayer.getSource().clear();
            _this._pointLayer.getSource().addFeature(locationFeature);
        };
        this.getDistanceFromMapCenter = function (lonlat) {
            var mapCenterLonLat = olProj.toLonLat(_this._map.olMap.getView().getCenter(), _this._map.options.displayProjection);
            return olSphere.getDistance(mapCenterLonLat, lonlat);
        };
        this.initBase();
    }
    Object.defineProperty(GazetteerBase.prototype, "displayProjection", {
        get: function () {
            return this._displayProjection;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GazetteerBase.prototype, "input", {
        get: function () {
            return this._input;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GazetteerBase.prototype, "resultsSelect", {
        get: function () {
            return this._resultsSelect;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GazetteerBase.prototype, "noResults", {
        get: function () {
            return this._noResults;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GazetteerBase.prototype, "loadingIndicator", {
        get: function () {
            return this._loadingIndicator;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GazetteerBase.prototype, "element", {
        get: function () {
            return this._element;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GazetteerBase.prototype, "searchResults", {
        get: function () {
            return this._searchResults;
        },
        set: function (results) {
            this._searchResults = results;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GazetteerBase.prototype, "pointLayer", {
        get: function () {
            return this._pointLayer;
        },
        enumerable: false,
        configurable: true
    });
    return GazetteerBase;
}());
exports.GazetteerBase = GazetteerBase;
//# sourceMappingURL=GazetteerBase.js.map